import { render, staticRenderFns } from "./PageNavigation.vue?vue&type=template&id=5cb1851d"
import script from "./PageNavigation.js?vue&type=script&lang=js&external"
export * from "./PageNavigation.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports